import React, { useState } from "react";
import VoiceChat from "./AI_VoiceRecognition"; 
import VoiceChatUI from "./VoiceChatUI";

const VoiceChatApp = ({ conversationHistory, setConversationHistory }) => {
  const [transcript, setTranscript] = useState("");
  const [response, setResponse] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [saveConversation, setSaveConversation] = useState(true);

  const startListening = () => setIsListening(true);
  const stopListening = () => setIsListening(false);

  /**
   * Called by VoiceChatUI after user hits "Send"
   * 
   */


  return (
    <VoiceChat 
      transcript={transcript}
      setTranscript={setTranscript}
      response={response}
      setResponse={setResponse}
      isListening={isListening}
      setIsListening={setIsListening}
      saveConversation={saveConversation}
      setSaveConversation={setSaveConversation}
      conversationHistory={conversationHistory}
      setConversationHistory={setConversationHistory}
    >
      <VoiceChatUI
        onStartListening={startListening}
        onStopListening={stopListening}
        isListening={isListening}
        userMessage={transcript}
        setUserMessage={setTranscript}
        saveConversation={saveConversation}
        setSaveConversation={setSaveConversation}
      />
    </VoiceChat>
  );
};

export default VoiceChatApp;
